import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function Problem() {
  const problems = ['te dejan con hambre', 'te quitan todo lo rico', 'te hacen bajar y luego rebotar', 'te complican la vida social', 'te hacen sentir culpa cada vez que sales a comer'];
  return <section className="py-20 bg-white border-b border-gray-100" data-id="element-242">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-243">
        <FadeIn data-id="element-244">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-warm-brown mb-12" data-id="element-245">
            Si ya intentaste dietas que...
          </h2>
        </FadeIn>

        <div className="bg-warm-beige/30 rounded-3xl p-8 md:p-12 shadow-sm border border-warm-beige" data-id="element-246">
          <div className="space-y-6 mb-12" data-id="element-247">
            {problems.map((problem, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-248">
                <div className="flex items-start" data-id="element-249">
                  <XCircle className="text-terracotta shrink-0 mt-1 mr-4" size={24} data-id="element-250" />
                  <p className="text-lg md:text-xl text-gray-700 font-medium" data-id="element-251">
                    {problem}
                  </p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.6} data-id="element-252">
            <div className="text-center space-y-6 pt-8 border-t border-warm-brown/20" data-id="element-253">
              <h3 className="text-2xl md:text-3xl font-serif font-bold text-olive-green leading-snug" data-id="element-254">
                Si te identificas con algo de esto, el problema no eres tú.
              </h3>
              <p className="text-xl text-gray-700 max-w-2xl mx-auto leading-relaxed font-medium" data-id="element-255">
                El problema es que el método que usaste no fue diseñado para la
                vida real.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}